import "core-js/modules/es.function.name.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-19880b15"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "SArtist"
};
var _hoisted_2 = {
  class: "SArtist-box"
};
var _hoisted_3 = ["onClick"];

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artistList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "Artist-item",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.songerClick(item.id);
      }
    }, [_createVNode(_component_el_image, {
      src: item.img1v1Url
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_4];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createElementVNode("span", {
      class: "songer-name",
      innerHTML: _ctx.lightKeyword(item.name, _ctx.inputValue)
    }, null, 8
    /* PROPS */
    , _hoisted_5)], 8
    /* PROPS */
    , _hoisted_3);
  }), 128
  /* KEYED_FRAGMENT */
  ))])]);
}